import { ObjetKStatus } from '@siclop/kstone-vue'
import type { DesignSystem } from './DesignSystem'

/**
 * Component instance on the wireframe canvas
 */
export interface ComponentInstance {
  id: string
  componentId: number
  componentCode: string
  x: number
  y: number
  width: number
  height: number
  rotation: number
  zIndex: number
  locked: boolean
  visible: boolean
  properties: Record<string, unknown>
  componentVersion: number
  groupId?: string  // Optional group identifier for element grouping
}

/**
 * Wireframe/mockup canvas
 */
export class Wireframe extends ObjetKStatus {
  functionalityId?: number
  functionalityCode?: string
  functionalityTitle?: string
  projectId?: number
  projectName?: string
  designSystemId: number = 1
  name: string = ''
  description?: string
  canvasWidth: number = 1920
  canvasHeight: number = 1080
  backgroundColor: string = '#FFFFFF'
  canvasDataJson: string = '[]'
  thumbnail?: string
  version: number = 1
  order: number = 0
  designSystem?: DesignSystem

  constructor(data?: Partial<Wireframe>) {
    super(data)
    if (data) {
      this.functionalityId = data.functionalityId
      this.functionalityCode = data.functionalityCode
      this.functionalityTitle = data.functionalityTitle
      this.projectId = data.projectId
      this.projectName = data.projectName
      this.designSystemId = data.designSystemId ?? 1
      this.name = data.name ?? ''
      this.description = data.description
      this.canvasWidth = data.canvasWidth ?? 1920
      this.canvasHeight = data.canvasHeight ?? 1080
      this.backgroundColor = data.backgroundColor ?? '#FFFFFF'
      this.canvasDataJson = data.canvasDataJson ?? '[]'
      this.thumbnail = data.thumbnail
      this.version = data.version ?? 1
      this.order = data.order ?? 0
      this.designSystem = data.designSystem
    }
  }

  /**
   * Parse canvasDataJson to ComponentInstance array
   */
  get canvasData(): ComponentInstance[] {
    try {
      return JSON.parse(this.canvasDataJson)
    } catch {
      return []
    }
  }

  /**
   * Set canvas data from array
   */
  set canvasData(value: ComponentInstance[]) {
    this.canvasDataJson = JSON.stringify(value)
  }
}
